import { Button } from 'components/Button';
import { Card } from 'components/Card';
import { CardGeneric } from 'components/CardGeneric';
import { CardRow } from 'components/CardRow';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { Txt } from 'components/Txt';
import { format } from 'date-fns';
import { useConfirm } from 'hooks/useConfirm';
import { useEsc } from 'hooks/useEsc';
import { UI_DATE_FORMAT_LONG } from 'lib/constants';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { TfaSetupComponent } from 'screens/AuthDialog/TfaSetupComponent';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import { REMOTE_ACCOUNT_SAVE_TFA } from 'store/remote/actions';

export const ProfileTfaScreen: React.FC<
  ModalScreenProps<ModalScreens.SETTINGSPROFILETFA>
> = ({ route }) => {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const tfa = route.params;
  const secret: string = tfa.secret || '';
  const uri = tfa.uri || '';
  const { required } = tfa;

  const handleDisableTfa = () => {
    confirm({
      confirmText: 'Disable TFA',
      destructive: true,
      onConfirm: () => dispatch(REMOTE_ACCOUNT_SAVE_TFA(undefined)),
      text: 'Are you sure you want to disable multi-factor authentication on your account?',
    });
  };

  const handleVerificationCodeChange = (value: string) => {
    if (value.length === 6) {
      dispatch(REMOTE_ACCOUNT_SAVE_TFA({ token: value }));
    }
  };

  useEsc(() => dispatch(NAVIGATE_MODAL_BACK()));

  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="Multi-Factor Authentication"
          onPressCancelButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      {!tfa.enabled ? (
        <TfaSetupComponent
          secret={secret}
          uri={uri}
          required={required}
          onSubmit={(code) => handleVerificationCodeChange(code)}
          withScrollView={false}
        />
      ) : (
        <>
          <CardGeneric>
            <Txt>
              <Txt weight="bold">MFA is enabled on your account.</Txt> RiskBase
              will ask for a code generated by your MFA app every time you sign
              in
            </Txt>
          </CardGeneric>
          <Card>
            <CardRow
              label={`Enabled on ${format(
                new Date(tfa.enabledTime),
                UI_DATE_FORMAT_LONG,
              )}`}
              labelColor={theme.colors.green}
            >
              <Button text="Disable" onPress={handleDisableTfa} destructive />
            </CardRow>
          </Card>
        </>
      )}
    </Page>
  );
};
